import * as S from './Input.styled'

const Input = (props) => {
  return <S.Input {...props} />
}

export default Input
